export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Statistics',
    icon: 'BarChartIcon',
    children: [
      {
        title: 'restaurantDashboard',
        route: 'restaurantDashboard',
        permission: 'viewRestaurantDashboard',
        isForRestaurant: true,
        isFav: false,
      },
      {
        title: 'branchesDashboard',
        route: 'branchesDashboard',
        permission: 'viewBranchesDashboard',
        isFav: false,
      },
      {
        title: 'usersAndAgentsDashboard',
        route: 'usersAndAgentsDashboard',
        permission: 'viewUsersAndAgentsDashboard',
        isFav: false,
      },
      {
        title: 'salesDashboard',
        route: 'invoice-dashboard',
        permission: 'viewSalesDashboard',
        isFav: false,
      },
      {
        title: 'purchaseDashboard',
        route: 'purchase-dashboard',
        permission: 'viewPurchDashboard',
        isFav: false,
      },
      {
        title: 'concreteDashboard',
        route: 'concreteDashboard',
        permission: 'viewConcreteDashboard',
        isForConcrete: true,
        isFav: false,
        tag: 'new'
      },
    ],
  },
  {
    title: 'mainData',
    icon: 'ArchiveIcon',
    children: [
      {
        title: 'safes',
        route: 'safes',
        permission: 'viewSafes',
        isFav: false,
      },
      {
        title: 'banks',
        route: 'banks',
        permission: 'viewBanks',
        isFav: false,
      },
      {
        title: 'Payment Methods',
        route: 'payment-methods',
        permission: 'viewPaymentMethods',
        isFav: false,
      },
      {
        title: 'warehouses',
        route: 'warehouses',
        permission: 'viewStores',
        isFav: false,
      },
      {
        title: 'areas',
        route: 'areas',
        permission: 'viewAreas',
        isFav: false
      },
      {
        title: 'agentItinerariesStatus',
        route: 'agent-itineraries-status',
        permission: 'viewAgentItinerariesStatus',
        isFav: false,
        tag: 'new',
      },
      {
        title: 'incomeType',
        route: 'income-type',
        permission: 'viewIncomes',
        isFav: false,
      },
      {
        title: 'expenseType',
        route: 'expense-type',
        permission: 'viewExpenses',
        isFav: false,
      },
      {
        title: 'tables',
        route: 'tables',
        permission: 'viewTables',
        isFav: false,
        isForRestaurant: true
      },
      {
        title: 'Discount Types',
        route: 'discount-types',
        permission: 'viewDiscountTypes',
        isFav: false,
      },
      {
        title: 'safeTransaction',
        route: 'safe-transaction',
        permission: 'viewSafeTransactions',
        isFav: false,
      },
      {
        title: 'exchangeDestinations',
        route: 'exchange-destinations',
        permission: 'viewExchangeDestinations',
        isFav: false,
      },
      {
        title: 'carColors',
        route: 'car-colors',
        permission: 'viewColors',
        isFav: false,
        isForCarShowroom: true,
      }
    ],
  },
  {
    title: 'items',
    icon: 'ShoppingBagIcon',
    children: [
      {
        title: 'Units',
        route: 'units',
        permission: 'viewUnits',
        isFav: false
      },
      {
        title: 'itemsCategory',
        route: 'items-category',
        permission: 'viewItemCategories',
        isFav: false,
      },
      {
        title: 'priceLists',
        route: 'priceLists',
        permission: 'viewPriceLists',
        isFav: false,
        isForPriceLists: true,
      },
      {
        title: 'listItems',
        route: 'items',
        permission: 'viewItems',
        isFav: false,
      },
    ],
  },
  {
    title: 'concrete',
    icon: 'ShoppingBagIcon',
    isForConcrete: true,
    children: [
      {
        title: 'Cars',
        route: 'cars',
        permission: 'viewCars',
        isFav: false,
        isForConcrete: true,
      },
      {
        title: 'Projects',
        route: 'projects',
        permission: 'viewProjects',
        isForConcrete: true,
        isFav: false
      },
      {
        title: 'Drivers',
        route: 'drivers',
        permission: 'viewDrivers',
        isForConcrete: true,
        isFav: false
      },
      {
        title: 'cementTypes',
        route: 'cementTypes',
        permission: 'viewCementTypes',
        isForConcrete: true,
        isFav: false
      },
      {
        title: 'maxTemperature',
        route: 'maxTemperature',
        permission: 'viewMaxTemperature',
        isForConcrete: true,
        isFav: false
      },
      {
        title: 'castingTypes',
        route: 'castingTypes',
        permission: 'viewCastingTypes',
        isForConcrete: true,
        isFav: false
      },
    ],
  },
  {
    title: 'dealers',
    icon: 'UsersIcon',
    children: [
      {
        title: 'customers',
        route: 'customers',
        permission: 'viewCustomers',
        isFav: false,
      },
      {
        title: 'suppliers',
        route: 'suppliers',
        permission: 'viewSuppliers',
        isFav: false,
      },
      {
        title: 'agents',
        route: 'agents',
        permission: 'viewAgents',
        isFav: false,
      },
      {
        title: 'agentItinerary',
        route: 'agentItinerary',
        permission: 'viewAgentItinerary',
        isFav: false,
      },
      {
        title: 'dealersClassification',
        route: 'dealersClassification',
        permission: 'viewDealersClassification',
        isFav: false,
      },
      {
        title: 'mediatorSystem',
        route: 'mediatorSystem',
        permission: 'viewMediatorSystem',
        isFav: false,
        isForMediatorSystems: true
      },
      {
        title: 'mainDealer',
        route: 'mainDealer',
        permission: 'viewMainDealer',
        isFav: false,
      },
    ],
  },
  {
    title: 'sales',
    icon: 'ArchiveIcon',
    children: [
      {
        title: 'allInovice',
        route: 'invoice-list',
        permission: 'viewTransactions',
        isFav: false,
      },
      {
        title: 'quotation',
        route: 'pos-quotation',
        permission: 'addQuotations',
        isFav: false,
      },
      {
        title: 'salesOrder',
        route: 'sales-order-new',
        permission: 'addSalesOrders',
        isFav: false,
        isNotForConcrete: true
      },
      {
        title: 'createUnderReview',
        route: 'underReview-new',
        permission: 'viewUnderProcedureTransaction',
        isFav: false,
        tag: 'new',
        isNotForConcrete: true
      },
      {
        title: 'createConcreteUnderReviewTransaction',
        route: 'concrete-under-review-new',
        permission: 'viewUnderProcedureTransaction',
        isFav: false,
        tag: 'new',
        isForConcrete: true
      },
      {
        title: 'reservations',
        route: 'reservations-new',
        permission: 'addReservations',
        isFav: false,
        isForConcrete: true
      },
      {
        title: 'contracts',
        route: 'contracts-new',
        permission: 'addSalesOrders',
        isFav: false,
        isForContracts: true,
        isForConstruction: true,
      },
      {
        title: 'salesPoint',
        route: 'pos-invoice',
        permission: 'addSalesTransactions',
        isFav: false
      },
      {
        title: 'concreteSalesInvoice',
        route: 'concrete-sales-invoice',
        permission: 'addConcreteTransactions',
        isFav: false,
        isForConcrete: true
      },
      {
        title: 'returnSales',
        route: 'return-sales-new',
        permission: 'addReturnSalesTransactions',
        isFav: false,
      },
      {
        title: 'pointOfSale',
        route: 'point-of-sale',
        permission: 'addPointOfSales',
        isFav: false,
      },
      {
        title: 'restaurantMenu',
        route: 'restaurant-menu',
        permission: 'viewResturantOrders',
        isFav: false,
        isForRestaurant: true
      },
      {
        title: 'restaurant-orders',
        route: 'restaurant-orders',
        permission: 'viewKitchenOrders',
        isFav: false,
        isForRestaurant: true
      },
    ],
  },
  {
    title: 'purchase',
    icon: 'ArchiveIcon',
    children: [
      {
        title: 'allPurchInovice',
        route: 'purchInvoice-list',
        permission: 'viewPurchTransactions',
        isFav: false,
      },
      {
        title: 'purchOrder',
        route: 'purchOrder',
        permission: 'addPurchOrders',
        isFav: false,
      },
      {
        title: 'purch',
        route: 'purchInvoice',
        permission: 'addPurchTransactions',
        isFav: false,
      },
      {
        title: 'returnPurch',
        route: 'return-purch-new',
        permission: 'addReturnPurchTransactions',
        isFav: false,
      }
    ],
  },
  {
    title: 'Stores',
    icon: 'ShoppingBagIcon',
    children: [
      {
        title: 'orders',
        route: 'orders',
        permission: 'viewStockCategoryTransactions',
        isFav: false,
      },
      {
        title: 'exchangeOrder',
        route: 'exchange-order-new',
        permission: 'viewExchangeOrders',
        isFav: false,
      },
      {
        title: 'ConcreteExchangeOrder',
        route: 'concrete-exchange-order-new',
        permission: 'addConcreteDelivery',
        isFav: false,
        isForConcrete: true
      },
      {
        title: 'additionOrder',
        route: 'addition-order-new',
        permission: 'viewAdditionOrders',
        isFav: false,
      },
      {
        title: 'manufacturingOrder',
        route: 'manufacturing-order-new',
        permission: 'viewManufacturingOrders',
        isFav: false,
      },
      {
        title: 'storageTransfer',
        route: 'storage-transfer',
        permission: 'viewStorageTransfer',
        isFav: false,
      },
      {
        title: 'storageTransferAcceptance',
        route: 'storage-transfer-acceptance',
        permission: 'viewStorageTransferAcceptance',
        isFav: false,
        isForStorageTransferAcceptance: true,
      },
      {
        title: 'damageAdjustment',
        route: 'damage-adjustment',
        permission: 'viewDamageAdjustments',
        isFav: false,
      },
    ],
  },
  {
    title: 'inventory-wharehous',
    icon: 'ShoppingBagIcon',
    children: [
      {
        title: 'inventory',
        route: 'inventory',
        permission: 'viewStocktaking',
        isFav: false,
      },
      {
        title: 'shortageAdjustment',
        route: 'shortage-adjustment',
        permission: 'viewShortageAdjustments',
        isFav: false,
      },
      {
        title: 'overflowAdjustment',
        route: 'overflow-adjustment',
        permission: 'viewOverflowAdjustments',
        isFav: false,
      },
    ],
  },
  {
    title: 'assets',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Collection Transaction',
        route: 'collection-transactions',
        permission: 'viewCollectionTransactions',
        isFav: false,
      },
      {
        title: 'customerDiscountTransaction',
        route: 'customer-discount',
        permission: 'viewCustomerDiscountTransactions',
        isFav: false,
      },
      {
        title: 'paymentTransaction',
        route: 'payment-transactions',
        permission: 'viewPaymentTransactions',
        isFav: false,
      },
      {
        title: 'Supplier Discount Transaction',
        route: 'supplier-discount',
        permission: 'viewSupplierDiscountTransactions',
        isFav: false,
      },
      {
        title: 'expenseTransaction',
        route: 'expense-transactions',
        permission: 'viewExpenseTransactions',
        isFav: false,
      },
      {
        title: 'Income Transaction',
        route: 'income-transactions',
        permission: 'viewIncomeTransactions',
        isFav: false,
      },
      {
        title: 'transfersAndSettlements',
        route: 'transfers-and-settlements',
        permission: 'viewTransfersAndSettlements',
        isFav: false,
      },
    ],
  },
  {
    title: 'accounts',
    icon: 'DollarSignIcon',
    isEnabled: true,
    children: [
      {
        title: 'chartOfAccount',
        route: 'chartOfAccount',
        permission: 'viewAccounts',
        isFav: false,
        isEnabled: true,
      },
      {
        title: 'accountGroups',
        route: 'account-groups',
        permission: 'viewAccountGroups',
        isFav: false,
        isEnabled: true,
      },
      {
        title: 'costCenter',
        route: 'costCenter',
        permission: 'viewCostCenters',
        isFav: false,
        isEnabled: true,
      },
      {
        title: 'postVouchers',
        route: 'post-vouchers',
        permission: 'gLPost',
        isFav: false,
        isEnabled: true,
      },
      {
        title: 'bulkInvoices',
        route: 'bulk-invoices',
        permission: 'editCompany',
        isFav: false,
        isForAdmin: true
      },
      {
        title: 'vouchers',
        route: 'vouchers',
        permission: 'viewVouchers',
        isFav: false,
        isEnabled: true,
      },
    ],
  },
  {
    title: 'Settings',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'company',
        route: 'company',
        permission: 'editCompany',
        isFav: false,
      },
      {
        title: 'Branches',
        route: 'branches',
        permission: 'viewBranches',
        isFav: false,
      },
      {
        title: 'loyaltyPointsSetting',
        route: 'loyalty-points',
        permission: 'viewLoyaltyPoints',
        isFav: false,
        isPoints: true,
      },
      {
        title: 'users',
        route: 'users',
        permission: 'viewUsers',
        isFav: false
      },
      {
        title: 'logs',
        route: 'logs',
        permission: 'viewUsers',
        isFav: false
      },
      {
        title: 'posConfigurations',
        route: 'posConfigurations',
        permission: 'editCompany',
        isForZatca: true,
        isFav: false,
      },
      {
        title: 'actions',
        route: 'actions',
        permission: 'viewActions',
        isFav: false,
      },
      {
        title: 'sendInvoiceToZatca',
        route: 'sendInvoiceToZatca',
        permission: 'sendInvoiceToZatca',
        isFav: false,
        isForZatca: true,
      },
      {
        title: 'snaPosPaymentMethods',
        route: 'snaPos-payment-methods',
        permission: 'editCompany',
        isFav: false,
        isForSnaPos: true,
      },
    ],
  },
  {
    title: 'reports',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'sales-reports',
        route: 'sales-reports',
      },
      {
        title: 'purchase-reports',
        route: 'purchase-reports',
      },
      {
        title: 'items-reports',
        route: 'items-reports',
      },
      {
        title: 'customers-and-suppliers',
        route: 'customers-and-suppliers',
      },
      {
        title: 'concrete-reports',
        route: 'concrete-reports',
        isForConcrete: true,
      },
      {
        title: 'accounts-reports',
        route: 'accounts-reports',
        isEnabled: true,
      },
    ],
  },
];
